import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    fullScreenContainer: {
        width: "100vw",
        height: "100vh",
        lineHeight: "100vh",
        textAlign: "center",
        backgroundColor: theme.colors.white,
    },
}));

export default useStyles;
